<template>
  <div>
    <CurrentStockAdjustTemp goods-option="S0100" goods-type="완제품"/>
  </div>

</template>

<script>
import CurrentStockAdjustTemp from './CurrentStockAdjustTemp'
export default {
  name: 'CurrentProductionStockAdjust',
  data: function () {
    return {
    }
  },
  components: {
    CurrentStockAdjustTemp
  },
  created () {
  },
  mounted () {
  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
  }
}
</script>

<style lang="scss">

</style>
